import { SlashCommandGroup } from "../../../../core/types";
export const slashCommandGroupLabels = {
    // TODO: localize
    [SlashCommandGroup.Basics]: `The Basics`,
    [SlashCommandGroup.Advanced]: `Advanced`,
    [SlashCommandGroup.Ai]: `AI`,
};
export const slashCommandGroupOrder = [
    slashCommandGroupLabels[SlashCommandGroup.Ai],
    slashCommandGroupLabels[SlashCommandGroup.Basics],
    slashCommandGroupLabels[SlashCommandGroup.Advanced],
];
